import { render, staticRenderFns } from "./NumberSelectorElement.vue?vue&type=template&id=27e0fb0d&scoped=true&"
import script from "./NumberSelectorElement.vue?vue&type=script&lang=js&"
export * from "./NumberSelectorElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0fb0d",
  null
  
)

export default component.exports